import { Page } from '@roc/feature-app-core';
import { Route } from 'react-router';
import { useRocInternalPortalStore } from '../../../hooks';
import { ValuationReview } from '@roc/feature-valuation-review';
import { InternalValuationReviewIframe } from '@roc/feature-valuation-review-v2';

export const getValuationReviewInternalRoutesConfig = (
  basePath: string,
  baseUrl: string,
) => {
  return {
    valuationReview: {
      path: `${basePath}/valuation-review`,
      url: `${baseUrl}/valuation-review`,
      documentTitle: 'valuation-review',
    },
    valuationReviewV2: {
      path: `${basePath}/valuation-review-v2`,
      url: `${baseUrl}/valuation-review-v2`,
      documentTitle: 'valuation-review-v2',
    },
  };
};

export const getValuationReviewInternalRoutes = (
  basePath: string,
  baseUrl: string,
  loanId: any,
  propertyId: any,
  readOnly: any
) => {
  const config = getValuationReviewInternalRoutesConfig(basePath, baseUrl);
  const { valuationReviewReportStore, internalValuationReviewStore } = useRocInternalPortalStore();

  return {
    valuationReview: (
      <Route exact path={config.valuationReview.path}>
        <Page routeDefinition={config.valuationReview}>
          <ValuationReview store={valuationReviewReportStore} loanId={loanId} propertyId={propertyId} readOnlyMode={readOnly === "true"} />
        </Page>
      </Route>
    ),
    valuationReviewV2: (
      <Route exact path={config.valuationReviewV2.path}>
        <Page routeDefinition={config.valuationReviewV2}>
          <InternalValuationReviewIframe internalValuationReviewStore={internalValuationReviewStore} loanId={loanId} propertyId={propertyId} readOnly={readOnly === "true"} />
        </Page>
      </Route>
    ),
  };
}